module.exports = __webpack_public_path__ + "static/media/funitures5.996bb60e.svg";